import moment from "moment"

export default function dateToString(date) {
    return moment(date).format('yyyy-MM-DD')
}